import PropTypes from "prop-types"

import Breadcrumb from "./breadcrumb"

const InfoLayoutRebrand = ({ children, heading, title }) => (
  <>
    <div className="contained-wide widescreen:px-60 px-16">
      <Breadcrumb title={heading || title} />
    </div>
    {children}
  </>
)

InfoLayoutRebrand.propTypes = {
  children: PropTypes.element.isRequired,
  heading: PropTypes.string,
  title: PropTypes.string.isRequired,
}

export default InfoLayoutRebrand
